<template>
  <div class="card" style>
    <img class="card-img-top" alt="..." v-bind:src="obrazek" />
    <div class="card-body">
      <h2 class="card-title">{{nazev}}</h2>

      <span
        style="font-size:100%;"
        v-bind:key="stitek"
        v-for="(stitek) in stitky"
        class="stitek badge badge-success"
      >{{stitek}}</span>

      <div class="container">
        <div class="odsun row border-top border-secondary">
          <div style="font-weight: bold;" class="col-sm odsun">{{dobaPripravy}}</div>
          <div style="font-weight: bold;" class="col-sm odsun">{{porce}} lidí</div>
        </div>
      </div>
      <div
        style="padding: 0px;"
        class="odsun d-flex justify-content-center container border-top border-secondary"
      >
        <div class="row">
          <div style="padding: 0px!important" class="col-sm">
            <ul class="list-group list-group-flush" v-if="showLess">
              <li
                class="list-group-item"
                v-bind:key="surovina"
                v-for="(surovina) in suroviny.slice(0,3)"
              >{{surovina}}</li>
              <li @click="showMoreSuroviny">více</li>
            </ul>

            <ul class="list-group list-group-flush" v-else>
              <li
                class="list-group-item"
                v-bind:key="surovina"
                v-for="(surovina) in suroviny"
              >{{surovina}}</li>
              <li @click="showLessSuroviny">méně</li>
            </ul>
          </div>
          <div class="col-sm">
            <ul class="list-group list-group-flush" v-if="showLessKoreni">
              <li class="list-group-item" v-bind:key="k" v-for="(k) in koreni.slice(0,3)">{{k}}</li>
              <li @click="showMoreKoreni">méně</li>
            </ul>
            <ul class="list-group list-group-flush" v-else>
              <li class="list-group-item" v-bind:key="k" v-for="(k) in koreni">{{k}}</li>
              <li @click="showLessKoreni">méně</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column-reverse" style="width:auto">
      <router-link class="btn odsun btn-success" style="margin:20px" :to="id">Otevři recept</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    nazev: String,
    obrazek: String,
    dobaPripravy: String,
    porce: String,
    stitky: Array,
    suroviny: Array,
    koreni: Array,
    id: String
  },
  data: () => {
    return {
      showLess: true,
      showLessKoreni: true
    };
  },
  methods: {
    showMoreSuroviny: () => {
      this.showLess = false;
    },
    showLessSuroviny: () => {
      this.showLess = true;
    },
    showLessKoreni: () => {
      this.showLessKoreni = true;
    },
    showMoreKoreni: () => {
      this.showLessKoreni = false;
    }
  }
};
</script>

<style scoped>
.odsun {
  margin-top: 12px;
}

.stitek {
  margin-bottom: 0px;
  margin-right: 5px;
}
</style>